// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/fes4uhy.css);"]);
// Module
exports.push([module.id, "@media (min-width:544px){.search-result__logo{margin-bottom:32px}.search-result__job-item{display:flex;margin-bottom:42px}.search-result__job-item--company{margin-right:24px;margin-bottom:0;flex:1}.search-result__job-item--location{flex:1;display:flex;justify-content:flex-end;font-size:18px}}", ""]);
// Exports
module.exports = exports;
